<style>
    .k-grid .k-header {
        white-space: normal;}
    .errMsg { color: #FF0000; }
</style>

<div class="sendToInvoice" style="height: calc(100vh - 15px);" *ngIf="showSendAccrualPanel">
    <div class="side-panel-content" [ngStyle]="{'width': showIntacctResponseSidePanel ? '1470px' : '870px'}"
        style="overflow-y: auto; overflow-x: hidden; display: flex; padding: 0 0px 0 0;">
        <div *ngIf="showIntacctResponseSidePanel" style="width: 600px; padding: 30px 0 0 0;">
            <div class="row" style="color: black; font-size: 30px;">
                <div class="col-md-12 align-center">
                    <label class="side-panel-header"><i class="fa fa-lg" style="padding-right: 1em;"></i>Intacct Response</label>
                </div>
            </div>
            <div style="overflow-y: scroll; overflow-x: hidden; height: calc(100vh - 80px);">
                <kendo-grid 
                    [data]="intacctResponse" 
                    [loading]="sendAccrualInProgress"
                    [ngStyle]="{height: 'calc(100vh - 80px)'}"
                    style="border: none;">
                    <kendo-grid-column field="message" title="Messages">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <span class="whole-cell" [ngClass]="{'errMsg': dataItem.isError}">
                                {{ dataItem.message }}
                            </span>
                            </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <div class="align-center side-panel-preview-separator"
            style="width: 30px; height: 100vh;" *ngIf="showIntacctResponseSidePanel"
            (click)="showIntacctResponseSidePanel = false;">
            <i class="fa fa-angle-right fa-2x" style="margin-top: calc(50vh - 30px);"></i>
        </div>
        <div style="width: 850px; padding: 30px 0 0 0;">
            <div class="row" style="color: black; font-size: 30px;">
                <div class="col-md-10 align-center">
                    <label class="side-panel-header"><i class="fa fa-lg fa-share rail360-success" style="padding-right: 1em;"></i>Send {{accrualData.journalTitle}} to Intacct</label>
                </div>
                <div class="col-md-2 align-center"><a class="side-panel-close" style="font-size: 25px;" 
                    (click)="closeComponent()">X</a>
                </div>  
            </div>         
            <div style="height: calc(100vh - 200px); overflow-y: auto; padding-top: 70px;">
                <div class="col-md-12">
                    <div class="row m-b" style="border-bottom: solid 1px #e5e6e7; padding-bottom: 6px;">
                        <div class="col-md-3" style="margin-left: -9px;">
                            <label>GL Posting Date <em class="text-danger">*</em></label>
                        </div>
                        <div class="col-md-3" style="margin-left: -10px;">
                            <label>GL Reverse Date <em class="text-danger">*</em></label>
                        </div>
                        <div class="col-md-3" style="margin-left: -2px">
                            <label>Attachment Folder Name <em class="text-danger">*</em></label>
                        </div>
                        <div class="col-md-3" style="margin-left: -4px">
                            <label>Memo</label>
                        </div>
                    </div>
                    <div class="row m-b" style="border-bottom: solid 1px #e5e6e7; padding-bottom: 10px;">
                        <div class="col-md-3">
                            <kendo-datepicker
                                style="margin-left: -9px"
                                name="GL Posting Date" 
                                [(ngModel)]="glPostingDate"
                                [min]="minGLPostingDate"
                                [max]="maxAllowedDate"
                                [required]
                                class="k-date-picker" 
                                placeholder=" " 
                                formatPlaceholder="short" 
                                id="GLPostingDate">
                            </kendo-datepicker>  
                        </div>
                        <div class="col-md-3">
                            <kendo-datepicker
                                style="margin-left: -15px"
                                name="GL Reverse Date" 
                                [(ngModel)]="glReverseDate" 
                                [min]="getMinGLReverseDate()"
                                [max]="maxAllowedDate"
                                [required]
                                class="k-date-picker" 
                                placeholder=" " 
                                formatPlaceholder="short" 
                                id="GLReverseDate">
                            </kendo-datepicker>  
                        </div>
                        <div class="col-md-3">
                            <input 
                                style="margin-left: -20px"
                                name="Attachment Folder Name" 
                                [(ngModel)]="accrualData.attachmentHeader.headerFolder"
                                type="text" 
                                class="form-control input-sm" 
                                [required]
                                id="attachmentFolderName">
                        </div>   
                        <div class="col-md-3">
                            <textarea
                                style="width: 120%; margin-left: -27px"
                                id="Memo"
                                rows="2"
                                name="Memo"
                                [(ngModel)]="memo">
                            </textarea>
                        </div>
                    </div>
                    <div class="row m-b" style="border-bottom: solid 1px #e5e6e7; padding-bottom: 10px;">
                        <div class="col-md-3">
                            <label style="font-size: 20px; font-weight: bold;">Preview</label>
                        </div>
                    </div>
                    <div class="row m-b">
                        <div class="col-md-3">
                            <label style="font-size: 14px; font-weight: bold;">Entries</label>
                        </div>
                    </div>
                    <kendo-grid 
                        style="height: calc(50vh - 100px); width: 100%; border: none;"
                        [data]="accrualData.entries"
                        [loading]="isInitDataLoading || sendAccrualInProgress">
                        <kendo-grid-column 
                            field="location" 
                            title="Location">
                        </kendo-grid-column>
                        <kendo-grid-column 
                            field="accountNo" 
                            title="Account">
                        </kendo-grid-column>
                        <kendo-grid-column 
                            field="transactionDebit" 
                            title="Transaction Debit">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.transactionDebit | currency }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column 
                            field="transactionCredit" 
                            title="Transaction Credit">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.transactionCredit | currency }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column 
                            field="baseDebit" 
                            title="Base Debit">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.baseDebit | currency }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column 
                            field="baseCredit" 
                            title="Base Credit">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{ dataItem.baseCredit | currency }}
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
            <div class="row" style="padding-top: -10px;">
                <div class="col-md-12" style="text-align: center; display: block;">
                    <button style="padding: 36px 40px; margin-right: 10px;"
                        name="sendtointacct" id="sendtointacct"
                        class="btn rail360-primary-item btn-sm side-panel-cfm-btn"
                        [disabled]="isSentToIntacct || sendAccrualInProgress || !glPostingDate || !glReverseDate || !accrualData.attachmentHeader.headerFolder || !accrualData.entries"
                        (click)="sendAccrualToIntacct()">Send
                    </button>
                </div>
            </div>
        </div>         
    </div>
</div>
